import EmptyItems from "@shared/components/EmptyItems";
import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";


interface MainBackbone {
  text: string;
}

const MainBackbone: React.FC = () => {
  const { handleSubmit } = useForm<MainBackbone>();

  const onSubmit: SubmitHandler<MainBackbone> = (data) => {
    console.log(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <EmptyItems/>
      </div>
    </form>
  );
};

export default MainBackbone;